const paragraph =
  `Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic provident
  vitae nisi consequuntur nihil nostrum quam ipsa sunt, et possimus
  ducimus repellat vero distinctio molestias soluta minima nesciunt
  commodi officia fugit saepe omnis accusamus. Commodi, laudantium.
  Alias nulla excepturi est perferendis similique velit consectetur
  repellat porro explicabo quis dolore, tempora assumenda,
  necessitatibus quia aliquam aut fugit! Hic aspernatur temporibus
  excepturi dignissimos vel iste, tempore voluptatem reprehenderit ipsam
  vitae ad incidunt.`.split("");

export default paragraph;
